// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"231cc0e3","453":"b4107a32","455":"aa7072c8","977":"83dd72ac"}[chunkId] + ".chunk.js";
};